module.exports = __webpack_public_path__ + "static/img/standard.0de06f06.jpg";